import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
import { useCountdown } from '../../hooks/useCountdown';
import { BookOpen, Trophy, ArrowRight } from 'lucide-react';
type PlanId = 'standard' | 'pack';
const plans = [{
  id: 'standard' as PlanId,
  icon: BookOpen,
  name: 'DE PAREJA A FAMILIA',
  meta: '3 tomos + 3 bonos estratégicos',
  oldPrice: '$34.990',
  price: '$19.990',
  cta: '💛 QUIERO EL STANDARD',
  link: 'https://checkout.ideahubdigital.online/cart/48886322102491:1',
  featured: false
}, {
  id: 'pack' as PlanId,
  icon: Trophy,
  name: 'PACK COMPLETO',
  meta: '3 tomos + 3 bonos + 2 Tomos de Posparto',
  oldPrice: '$43.990',
  price: '$29.990',
  cta: 'SÍ, QUIERO EL PACK COMPLETO',
  link: 'https://checkout.ideahubdigital.online/cart/48886322233563:1',
  featured: true
}];
export function FinalCTA() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(23, 47, 22);
  const [selected, setSelected] = useState<PlanId>('pack');
  const activePlan = plans.find(p => p.id === selected)!;
  return <section className="py-12 md:py-24 px-4 md:px-8 bg-brown text-offwhite" data-id="element-71">
      <div className="max-w-3xl mx-auto text-center" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-73">
          <h2 className="font-serif text-3xl md:text-5xl font-bold mb-4 md:mb-6" data-id="element-74">
            No dejen pasar esta oportunidad
          </h2>

          <div className="flex items-center justify-center gap-3 md:gap-4 mb-8 md:mb-12" data-id="element-75">
            <span className="font-sans text-sm md:text-base text-offwhite/70" data-id="element-76">
              Termina en
            </span>
            <div className="flex gap-1 md:gap-2 font-serif font-bold text-lg md:text-xl text-terracotta bg-offwhite/10 px-3 md:px-4 py-1.5 md:py-2 rounded-lg" data-id="element-77">
              <span data-id="element-78">{hours.toString().padStart(2, '0')} Horas</span>
              <span data-id="element-79">:</span>
              <span data-id="element-80">{minutes.toString().padStart(2, '0')} Min</span>
              <span data-id="element-81">:</span>
              <span data-id="element-82">{seconds.toString().padStart(2, '0')} Seg</span>
            </div>
          </div>

          {/* Selectable rows */}
          <div role="radiogroup" aria-label="Planes" className="space-y-3 md:space-y-4 text-left" data-id="element-83">
            {plans.map(plan => {
            const isSelected = selected === plan.id;
            return <motion.button key={plan.id} type="button" role="radio" aria-checked={isSelected} onClick={() => setSelected(plan.id)} whileTap={{
              scale: 0.99
            }} className={`w-full text-left rounded-2xl border-2 p-4 md:p-5 transition-colors ${isSelected ? 'border-terracotta bg-terracotta/15' : 'border-offwhite/15 bg-offwhite/5 hover:border-terracotta/40'}`} data-id="element-84">
                  <div className="flex items-start gap-3 md:gap-4" data-id="element-85">
                    {/* Radio */}
                    <span className={`mt-0.5 w-5 h-5 md:w-6 md:h-6 rounded-full border-2 shrink-0 flex items-center justify-center transition-colors ${isSelected ? 'border-terracotta' : 'border-offwhite/30'}`} data-id="element-86">
                      {isSelected && <span className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-terracotta" data-id="element-87" />}
                    </span>

                    <div className="flex-1 min-w-0" data-id="element-88">
                      <div className="flex items-start justify-between gap-3" data-id="element-89">
                        <div className="min-w-0" data-id="element-90">
                          <div className="flex items-center gap-2 mb-1 flex-wrap" data-id="element-91">
                            <plan.icon size={18} className="text-terracotta shrink-0" data-id="element-92" />
                            <h3 className="font-serif font-bold text-base md:text-lg text-offwhite" data-id="element-93">
                              {plan.name}
                            </h3>
                          </div>

                          {plan.featured && <div className="mb-1.5" data-id="element-94">
                              <span className="inline-block bg-terracotta text-offwhite font-sans font-bold text-[10px] md:text-xs px-2 py-0.5 rounded" data-id="element-95">
                                ⭐ MÁS ELEGIDO · AHORRÁS $14.000
                              </span>
                            </div>}

                          <p className="font-sans text-xs md:text-sm text-offwhite/60" data-id="element-96">
                            {plan.meta}
                          </p>
                        </div>

                        <div className="text-right shrink-0" data-id="element-97">
                          <span className="block line-through text-offwhite/40 font-sans text-xs md:text-sm" data-id="element-98">
                            {plan.oldPrice}
                          </span>
                          <span className="font-serif text-2xl md:text-3xl font-bold text-terracotta leading-none" data-id="element-99">
                            {plan.price}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.button>;
          })}
          </div>

          {/* Single CTA reflecting selection */}
          <div className="mt-5 md:mt-6" data-id="element-100">
            <CTAButton variant="primary" fullWidth className="!py-5 text-base md:text-lg" onClick={() => window.location.href = activePlan.link} data-id="element-101">
              {activePlan.cta}
              <ArrowRight size={20} className="ml-2" data-id="element-102" />
            </CTAButton>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-3 md:gap-6 mt-6 md:mt-8 text-xs md:text-sm font-sans text-offwhite/50" data-id="element-103">
            <div className="flex items-center gap-1.5 md:gap-2" data-id="element-104">
              Pago seguro
            </div>
            <div className="w-1 h-1 bg-offwhite/20 rounded-full" data-id="element-105"></div>
            <div className="flex items-center gap-1.5 md:gap-2" data-id="element-106">
              Acceso en 5 min
            </div>
            <div className="w-1 h-1 bg-offwhite/20 rounded-full" data-id="element-107"></div>
            <div className="flex items-center gap-1.5 md:gap-2" data-id="element-108">
              Garantía 7 días
            </div>
            <div className="w-1 h-1 bg-offwhite/20 rounded-full" data-id="element-109"></div>
            <div className="flex items-center gap-1.5 md:gap-2 font-bold" data-id="element-110">
              Mercado Pago
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}